export default "__VITE_ASSET__CQZah2C4__"